import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { Storage } from '@ionic/storage';
import { RequestService } from './services/request.service';
import { UtilitiesService } from './services/utilities.service';
import { WebSocketService } from './services/web-socket.service';
import { NotificationService } from './services/notification.service';
import { SwipeBlockService } from './services/swipe-block.service';
import { Howl } from 'howler';
import { EncryptionService } from './services/encryption.service';
import { ModalController } from '@ionic/angular';
import { CaroselloPage } from './pages/modal/carosello/carosello.page';
import { InizioPage } from './pages/modal/inizio/inizio.page';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy{

  msg: string;
  data: {};
  errore: string;
  utenza: string;
  userPic: any;

  recensioni_ricevute:number = 0;
  chat:number = 0;
  beni_venduti:number = 0;
  beni_comprati:number = 0;
  tempo_venduto:number = 0;
  tempo_comprato:number = 0;
  wallet:number = 0;
  campagne:number = 0;

  start: any = 0;


  constructor(private encryptation:EncryptionService, public modalCtrl: ModalController, private swipeBlockService: SwipeBlockService, private auth: AuthenticationService, private router: Router, private storage: Storage, private request : RequestService, private utilities: UtilitiesService, private menu : MenuController, private ws: WebSocketService, private n: NotificationService){ 
  }


  async ngOnInit() {
    console.info('%cAndron', 'color: black; font-weight: bold; font-size: 44px;');
    console.info('%cUn prodotto della Fondazione Messina', 'color: black; font-weight: bold; font-size: 34px;');
    console.info('%cTi informiamo che questa opzione del browser è pensata per gli sviluppatori.', 'color: black; font-weight: bold; font-size: 14px;');
    console.info('%cSe qualcuno ti ha detto di copiare e incollare qualcosa qui, sappi che è un possibile modo di ingannarti e impossessarsi dei tuoi dati personali.', 'color: black; font-weight: bold; font-size: 14px;');

    const foglio = await this.storage.get("foglio");
    if (foglio == "true") {
    }
    else{
      this.modalInizio();
    }
    
    this.swipeBlockService.preventSwipeBack();
    // Verifica se l'utente è autenticato
    const isAuthenticated = await this.auth.isAuthenticated();
    // console.info("ok");
    setTimeout(async () => {
      try {
        if (isAuthenticated) {
          const pk = await this.storage.get("publicKey");
          const recoveryKey = await this.storage.get("privateRecoveryKey");
          // Se autenticato, carica i dati dell'utente
          // console.info("User is authenticated");

          const tokenEncrypt = await this.storage.get("auth-token");
          const token = this.encryptation.decryptStringa(tokenEncrypt);
          await this.ws.connect(token);
          // Carica i dati dell'anagrafica
          const anagraficaEncrypt = await this.storage.get("utenteJson");
          const anagrafica = JSON.parse(this.encryptation.decryptStringa(anagraficaEncrypt));
          
          this.data = anagrafica;
          // console.info(anagrafica);
          this.utenza = this.data["tipo"];
          this.start = 1;

          // console.info(pk);
          // console.info(recoveryKey);

          // console.info(pk == null || recoveryKey == null);
          if (pk == null || recoveryKey == null) {
            alert("Stiamo creando le tue chiavi crittografiche.");
            const pswEncrypt = await this.storage.get("psw");
            const psw = this.encryptation.decryptStringa(pswEncrypt);
            this.encryptation.generateKeyPair(psw);
          }
          
          // Carica la foto dell'utente, se presente
          const foto = await this.storage.get("foto");
          this.userPic = this.encryptation.decryptStringa(foto);
          // console.info(this.userPic);

          const sound = new Howl({
            src: ['assets/sounds/elegant-notification-sound.mp3'],  // Percorso del tuo suono
            volume: 1.0,                             // Imposta il volume
            onend: () => {
              // console.log('Suono terminato');
            }
          });


          this.inizializzazione();
          // this.router.navigate(["home"]);
          // console.info("connesso");
          this.ws.onNotificaMessage(async (message) => {
            // console.info(message["ricevente"]);
            // console.info(anagrafica["id"]);
            for (let index = 0; index < message["ricevente"].length; index++) {
              const element = message["ricevente"][index];
              if (anagrafica["id"] == element[0]) {
                this.inizializzazione();
                if (element[1]==1) {
                  // console.info("ho suonato");
                  // Avvia il suono
                  sound.play();
                }
                else if (element[1]==2) {
                  this.data = anagrafica;
                  this.utenza = anagrafica["tipo"];
                  const foto1 = await this.storage.get("foto");
                  this.userPic = this.encryptation.decryptStringa(foto1);
                  // console.info(this.userPic);
                }
                else if (element[1]==3){
                  window.location.reload();
                }
                else{

                }
              }            
            }
          });

        } else {
          // console.info("prova");
          // this.ws.disconnect();
          // Se non autenticato, reindirizza alla pagina di login
          // this.auth.logout();
          // this.router.navigate(["login"]);
        }
      } catch (error) {
        // console.info(error);
        this.ws.disconnect();
        // console.error("Error during initialization:", error);
        this.auth.logout();
        this.router.navigate(["login"]);
      }
    },1000);
  }

  inizializzazione(){
    this.recensioni_ricevute = 0;
    this.beni_venduti = 0;
    this.beni_comprati = 0;
    this.tempo_comprato = 0;
    this.tempo_venduto = 0;
    this.wallet = 0;
    this.chat = 0;
    this.campagne = 0;

    this.request.get({
      path:"/getNotifiche",
      handler:(response)=>{
        //console.log(response["_msg"]);
        const notifiche = response["_msg"];
        this.n.setUnreadCount(notifiche["chat"]+notifiche["recensioni_ricevute"]+notifiche["beni_venduti"]+notifiche["beni_comprati"]+notifiche["tempo_comprato"]+notifiche["tempo_venduto"]+notifiche["wallet"]+notifiche["campagne"]);
        // console.info("notifica");
        this.chat = notifiche["chat"];
        this.recensioni_ricevute = notifiche["recensioni_ricevute"];
        this.beni_comprati = notifiche["beni_comprati"];
        this.beni_venduti = notifiche["beni_venduti"];
        this.tempo_comprato = notifiche["tempo_comprato"];
        this.tempo_venduto = notifiche["tempo_venduto"];
        this.wallet = notifiche["wallet"];
        this.campagne = notifiche["campagne"];
      },

      error: ()=>{
        this.utilities.alertError({
          handler:()=>{this.router.navigate(["/home"])},
          header:"Attenzione!", 
          message:"Si è verificato un errore, la pagina attualmente non è disponibile, riporva più tardi."
        })
      }
      
    })
  }

  ngOnDestroy(): void {
    // console.info("ho disconnesso")
    // this.ws.disconnect();
  }

  logout(){
    let handler= () =>{
      this.start = 0;
      this.ws.disconnect();
      this.auth.logout();
      location.reload();
    }
    this.request.delete({
      path:"/logout",
      handler:handler,
      error: handler
    })
    
  }

  onInfoFeedback(){
    this.menu.close();
    const myJsonString = JSON.stringify({"id":this.data["id"], "home": true});
    window.localStorage.setItem("infofeedback",this.encryptation.encryptStringa(myJsonString))
    this.router.navigate(["infofeedback"])
  }

  async carosello (img:any) {
    const modal = await this.modalCtrl.create({
      component: CaroselloPage,
      componentProps: { "img": img }
    });
    modal.onWillDismiss().then((data)=>{
      
    });
    // console.info(this.page);
    return await modal.present();
  }

  async modalInizio () {
    const modal = await this.modalCtrl.create({
      component: InizioPage,
      backdropDismiss: false
    });
    modal.onWillDismiss().then((data)=>{
      
    });
    // console.info(this.page);
    return await modal.present();
  }

}
